import React from "react";


class ConfirmDeactivateModal extends React.Component {

    constructor(props){

        super(props);


        this.state = {

            showDeactivateModal:false,

            selectedInstallation:null,

        }
    }


    render(){

        const installation = this.props.installation;


        if(!installation)
            return null;


        return (

            <div className="modal-overlay">


                <div className="confirm-modal">


                    <h3>
                        Deactivate MT5 Installation
                    </h3>


                    <p>

                        Are you sure you want to deactivate:

                    </p>


                    <strong>

                        {installation.symbol}
                        {" "}
                        {installation.timeframe}

                    </strong>


                    <div className="confirm-actions">


                        <button

                        className="btn-cancel"

                        onClick={
                            this.props.onCancel
                        }

                        >

                            Cancel

                        </button>



                        <button

                        className="btn-deactivate"

                        onClick={() =>
                            this.props.onConfirm(installation)
                        }

                        >

                            Deactivate

                        </button>


                    </div>


                </div>


            </div>

        );

    }

}


export default ConfirmDeactivateModal;